<div style="max-height: 300px;" fusePerfectScrollbar>
  <ng-container *ngIf="fieldSelectionViewModels">
    <div class="mat-panel-container">
      <mat-accordion
        class="flex flex-col"
        *ngFor="let viewModel of fieldSelectionViewModels">
        <mat-expansion-panel
          [expanded]="true"
          (click)="$event.stopPropagation();"
          hideToggle="true"
        >
          <mat-expansion-panel-header
            [collapsedHeight]="'auto'"
            [expandedHeight]="'auto'"
          >
            <mat-panel-title *ngIf="viewModel.fields && viewModel.fields.length > 0">
              <div  class="flex flex-row justify-start items-center full-grow-no-shrink-no-basis ">
                <mat-icon class="mat-icon-rtl-mirror" (click)="viewModel.isExpanded = !viewModel.isExpanded">
                  {{viewModel.isExpanded ? 'expand_more' : 'chevron_right'}}
                </mat-icon>
                <mat-checkbox
                  (click)="$event.stopPropagation();"
                  (change)="onSourceCheckBoxClicked($event, viewModel.title)"
                  [checked]="isAllSourceFieldSelected(viewModel.title)"
                  [indeterminate]="isViewModelInInterminateState(viewModel.title)"
                > {{viewModel.title}}
                </mat-checkbox>
                <div class="links flex flex-row justify-end items-center"></div>

              </div>
            </mat-panel-title>
          </mat-expansion-panel-header>
          <ul *ngIf="viewModel.fields" class="data-source-select-field">
            <li
              *ngFor="let field of viewModel.fields"
              [ngClass]="{checked: field.isChecked}"
              class="flex flex-row"
            >
              <mat-checkbox [checked]="field.isChecked" [disabled]="field.isDisabled"
                            (change)="onToogleCheckBox($event, field.key, viewModel.title)"
              >
                {{field.title}}
              </mat-checkbox>
              <div class="links flex flex-row justify-end items-center"></div>
            </li>
          </ul>
        </mat-expansion-panel>
      </mat-accordion>
    </div>
  </ng-container>
</div>
